import React from "react";
import { Redirect } from "react-router-dom";
// 시스템
import Login from "../pages/Authentication/Login/Login";
import Logout from "../pages/Authentication/Logout";
import SignUp from "../pages/Authentication/SignUp/SignUp";
import SignUpComplete from "../pages/Authentication/SignUp/SignUpComplete";
import ForgetId from "../pages/Authentication/Forget/ForgetId";
import ForgetPwd from "../pages/Authentication/Forget/ForgetPassword";
import FirstLogin from "../pages/Authentication/Login/FirstLogin";
import SelectCompany from "../pages/Authentication/SelectCompany/SelectCompany";
import RequestCreateCompany from "../pages/Authentication/RequestCreateCompany/RequestCreateCompany";
import RequestJoinCompany from "../pages/Authentication/RequestJoinCompany/RequestJoinCompany";

// 대시보드
import Dashboard from "../pages/Dashboard/index";
// 담당자 상담
import Counseling from "../pages/Counseling/Counseling";

// 할일
import Task from "../pages/Task";
import TaskIssue from "../components/Task/TaskIssueList";
// 커뮤니티
import Community from "../pages/Community/Community";
import CommunityList from "../pages/Community/CommunityList";
// 출퇴근
import AttendanceHistory from "../pages/Attendance/History";
import AttendanceManagement from "../pages/Attendance/Management";
import AttendanceWorkTime from "../pages/Attendance/WorkTime";
import AttendanceWorkDepartment from "../pages/Attendance/WorkDepartment";
import AttendanceLocation from "../pages/Attendance/Location/LocationList";
// 근무일정
import WorkScheduleManagement from "../pages/WorkSchedule/Management";
import WorkScheduleHoliday from "../pages/WorkSchedule/Holiday";
import WorkScheduleOtherWork from "../pages/WorkSchedule/OtherWork/OtherWorkList";
// 휴가
import VacationPlan from "../pages/Vacation/Plan";
// import VacationStatus from "../pages/Vacation/Status";
import VacationAssignStatus from "../pages/Vacation/AssignStatus";
import VacationStandard from "../pages/Vacation/Standard";
import VacationOther from "../pages/Vacation/OtherVacation";
// 급여
import SalaryHistorySelf from "../pages/Salary/SalaryHistorySelf";
import SalaryHistory from "../pages/Salary/SalaryHistory/SalaryHistoryList";
import SalaryItems from "../pages/Salary/SalaryItems";
// 사람
import PersonOrganization from "../pages/Person/Organization";
// 전자계약
import ElectronicContract from "../pages/ElectronicContract";
// 자금
import FundsReport from "../pages/Funds/Report";
import FundsOverview from "../pages/Funds/Overview";
import FundsAccount from "../pages/Funds/Account";
import FundsOther from "../pages/Funds/Other";
import FundsAccountDetail from "../pages/Funds/AccountDetail";
import FundsCard from "../pages/Funds/Card";
import FundsCardDetail from "../pages/Funds/CardDetail";
import FundsBondDebt from "../pages/Funds/BondDebt/BondDebtList";
import Categories from "../pages/Funds/Categories";
// 전자계산서
import ElectronicTradeBill from "../pages/ElectronicBill/Trade";
import ElectronicTaxBill from "../pages/ElectronicBill/Tax";
import ElectronicCashBill from "../pages/ElectronicBill/Cash";
import ElectronicPaperTaxBill from "../pages/ElectronicBill/TaxPaper/index";
// 경비 청구
import ExpenseClaimList from "../pages/ExpenseClaim/List/ExpenseList";
// 업로드
import UploadList from "../pages/Upload/List";
// 관리자
import ManagerCompanyInfo from "../pages/Manager/CompanyInfo";
import ManagerTask from "../pages/Manager/Roles";
import OutSideTask from "../pages/Manager/OutsideRoles";
import ManagerFinancial from "../pages/Manager/Financial";
import ManagerWorkPlace from "../pages/Manager/WorkPlace/WorkPlaceList";
// 품목
import ItemList from "../pages/Item";
// 거래처
import ClientList from "../pages/Client/ClientList";
// 프로필
import Profile from "../pages/Profile";

// 테스트페이지
import TestMask from "../pages/Test/Mask";
import TestDatePicker from "../pages/Test/DatePicker";
import TestButtons from "../pages/Test/Buttons";
import TestBadges from "../pages/Test/Badges";
import TestContentLayout from "../pages/Test/ContentLayout";
import CheckboxAndRadio from "../pages/Test/CheckboxAndRadio";
import ReduxAndReduxSaga from "../pages/Test/ReduxAndReduxSaga";
import FinancesCert from "../pages/Test/FinancesCert";

// 어드민 (경리대행)
import AdminCompanies from "../pages/Admin/companies";
import AdminConsultings from "../pages/Admin/Consultings";

// 매니저
import ManagingCompanies from "../pages/Managing/companies";
import ManagingConsultings from "../pages/Managing/Consultings";
import CounselingList from "../pages/Manager/Counseling/CounselingList";
import CareCompany from "../pages/Managing/CareCompany";

// 위픽
import WepickMailForm from "../pages/Wepick/MailForms";
import WepickSubscribers from "../pages/Wepick/Subscribers";

// 기타
import ContractWebView from "../pages/ElectronicContract/ContractWebView";
import YearEndList from "../pages/YaerEnd/List/YearEndList";
import ManagingCompany from "../pages/Managing/company";
import Partner from "../pages/Managing/Partner";
import AdminRemotes from "../pages/Admin/Remotes";
import AdminInquiry from "../pages/Admin/Inquiry";
import ManagingThroughMeCompanies from "../pages/Managing/ThroughMeCompanies";
import AdminNewsletter from "../pages/Admin/newsletter";
import AdminSeminarRecruitment from "../pages/Admin/Seminar/Recruitment";
import AdminSeminarCategories from "../pages/Admin/Seminar/Categories";
import AdminSeminarSession from "../pages/Admin/Seminar/Sessions";
import AdminSeminars from "../pages/Admin/Seminar/Seminars";
import AdminReservation from "../pages/Admin/Seminar/Reservation";
import AdminRecruits from "../pages/Admin/Recruits";
import QuotationOrder from "../pages/ElectronicBill/Quotation-order";
import AdminSeminarRequest from "../pages/Admin/Seminar/Request";
import AdminSeminarRequestRecruitment from "../pages/Admin/Seminar/RequestReservations";
import AdminMailUnsubscribe from "../pages/Admin/MailUnsubscribe";
import DeleteUser from "../pages/DeleteUser";
import NoticeBoards from "../pages/Notice-board";
import AdminTaxBoards from "../pages/Admin/TaxBoards";
import AdminMembership from "../pages/Admin/Membership";
import AdManagers from "../pages/Admin/AdManagers";

// TAX PORTAL
import TAXPORTAL_TaxDashboard from "../pages/TaxPortal/TaxDashboard";
import TAXPORTAL_TaxManagementPage from "../pages/TaxPortal/TaxManagement/TaxManagements";
import TAXPORTAL_ExposedInfo from "../pages/TaxPortal/ExposedInfo";
import TAXPORTAL_SiteInfo from "../pages/TaxPortal/SiteInfo";
import TAXPORTAL_Newsletter from "../pages/TaxPortal/NewsLetter";
import TAXPORTAL_Employee from "../pages/TaxPortal/Employee";
import TAXPORTAL_Managing from "../pages/TaxPortal/Managing";
import TAXPORTAL_Notices from "../pages/TaxPortal/NoticeBoard";
import TAXPORTAL_WECAKE_CUSTOMERS from "../pages/TaxPortal/Managing/WecakeCustomers";
import TAXPORTAL_COUNSELING from "../pages/TaxPortal/Counseling";
import TAXPORTAL_SCHEDULES from "../pages/TaxPortal/Schedules";
import TAXPORTAL_CUSTODIAN from "../pages/TaxPortal/TaxManagement/Custodian";
import TAXPORTAL_CONTRACT from "../pages/TaxPortal/Contract";
import TAXPORTAL_SETTINGS_HOMETAX from "../pages/TaxPortal/Settings/Hometax";
import TAXPORTAL_SETTINGS_WETAX from "../pages/TaxPortal/Settings/Wetax";
import TAXPORTAL_SETTINGS_SI4N from "../pages/TaxPortal/Settings/Si4n";
import TAXPORTAL_AdministrativeCertificate from "../pages/TaxPortal/AdministrativeCertificate";

import TAXPORTAL_TAX_CONSULTING from "../pages/TaxPortal/TaxConsulting/TaxConsulting";
// import TAXPORTAL_TAX_CONSULTING_LIST from "../pages/TaxPortal/TaxConsulting/TaxConsultingList";
import TAXPORTAL_TAX_CONSULTING_COLLABORATION from "../pages/TaxPortal/TaxConsulting/TaxConsultingCollaboration";
import TAXPORTAL_TAX_CONSULTING_SETTING from "../pages/TaxPortal/TaxConsulting/TaxConsultingSetting";


import TAXPORTAL_TAX_SINGO from "../pages/TaxPortal/TaxSingo/TaxSingo";
import TAXPORTAL_TAX_SINGO_CONFIGURATION from "../pages/TaxPortal/TaxSingo/TaxSingoConfigurationList";
import TAXPORTAL_Si4n from "../pages/TaxPortal/Si4n";

// PAY PORTAL
import PAYPORTAL_PayDashboard from "../pages/PayPortal/PayDashboard";


const adminRoutes = [
  // ADMIN Pages
  {
    path: "/admin/companies",
    component: AdminCompanies,
  },
  {
    path: "/admin/partners",
    component: AdminCompanies,
  },
  {
    path: "/admin/request-companies",
    component: AdminCompanies,
  },
  {
    path: "/admin/consultings",
    component: AdminConsultings,
  },
  {
    path: "/admin/free-trial",
    component: AdminConsultings,
  },
  {
    path: "/admin/inquiry",
    component: AdminInquiry,
  },
  {
    path: "/admin/remotes",
    component: AdminRemotes,
  },
  {
    path: "/admin/newsletter/subscribe",
    component: AdminNewsletter,
  },
  {
    path: "/admin/newsletter/board",
    component: AdminNewsletter,
  },
  {
    path: "/admin/newsletter/mail-form",
    component: AdminNewsletter,
  },
  {
    path: "/admin/seminar/recruitment",
    component: AdminSeminarRecruitment,
  },
  {
    path: "/admin/seminar/reservation",
    component: AdminReservation,
  },
  {
    path: "/admin/seminar/categories",
    component: AdminSeminarCategories,
  },
  {
    path: "/admin/seminar/session",
    component: AdminSeminarSession
  },
  {
    path: "/admin/seminar/seminar",
    component: AdminSeminars
  },
  {
    path: "/admin/recruits",
    component: AdminRecruits
  },
  {
    path: "/admin/seminar/request",
    component: AdminSeminarRequest
  },
  {
    path: "/admin/seminar/request-reservation",
    component: AdminSeminarRequestRecruitment
  },
  {
    path: "/admin/unsubscribe",
    component: AdminMailUnsubscribe
  },
  {
    path: "/admin/tax-boards",
    component: AdminTaxBoards
  },
  {
    path: "/admin/membership",
    component: AdminMembership
  },
  {
    path: "/admin/ad/manager",
    component: AdManagers
  },
];
const managerCompanyRoutes = [
  // MANAGER COMPANY Pages
  {
    path: "/managing/companies",
    component: ManagingCompanies,
  },
  {
    path: "/managing/company",
    component: ManagingCompany,
  },
  {
    path: "/managing/partner-request-companies",
    component: ManagingCompanies,
  },
  {
    path: "/managing/through-me-companies",
    component: ManagingThroughMeCompanies,
  },
  {
    path: "/managing/consultings",
    component: ManagingConsultings,
  },
  {
    path: "/managing/counseling",
    component: CounselingList,
  },
  {
    path: "/managing/notice-board",
    component: NoticeBoards,
  },
  {
    path: "/managing/carecompany",
    component: CareCompany,
  },
  {
    path: "/managing/partner",
    component: Partner,
  },
  {
    path: "/wepick/mail-form",
    component: WepickMailForm
  },
  {
    path: "/wepick/subscriber",
    component: WepickSubscribers
  },
];

const taxPortalRoutes = [
  // TAX_PORTAL
  // 대시보드
  {
    path: "/tax-portal/tax-dashboard",
    component: TAXPORTAL_TaxDashboard
  },
  // 수임관리
  {
    //수임현황
    path: "/tax-portal/tax-management",
    component: TAXPORTAL_TaxManagementPage
  },
  {
    // 수임처관리
    path: "/tax-portal/custodian",
    component: TAXPORTAL_CUSTODIAN
  },
  {
    // 계약 관리
    path: "/tax-portal/contract",
    component: TAXPORTAL_CONTRACT
  },
  // 업무관리
  {
    // 경리지원
    path: "/tax-portal/managing",
    component: TAXPORTAL_Managing
  },
  {
    // 일정
    path: "/tax-portal/schedules",
    component: TAXPORTAL_SCHEDULES
  },
  {
    // 위케이크 고객관리
    path: "/tax-portal/wecake-customers",
    component: TAXPORTAL_WECAKE_CUSTOMERS
  },
  {
    // 상담관리
    path: "/tax-portal/counseling",
    component: TAXPORTAL_COUNSELING
  },
  {
    // 공지사항 관리
    path: "/tax-portal/notices",
    component: TAXPORTAL_Notices
  },

  // 민원증명
  {
    // 민원증명
    path: "/tax-portal/administrative-certificate",
    component: TAXPORTAL_AdministrativeCertificate
  },

  // 민원증명
  {
    // 민원증명
    path: "/tax-portal/si4n",
    component: TAXPORTAL_Si4n
  },

  // 홍보지원
  {
    // 노출 정보 관리
    path: "/tax-portal/exposed-info",
    component: TAXPORTAL_ExposedInfo
  },
  {
    // 홈페이지 관리
    path: "/tax-portal/site-info",
    component: TAXPORTAL_SiteInfo
  },
  {
    // 뉴스레터 관리
    path: "/tax-portal/newsletter",
    component: TAXPORTAL_Newsletter
  },
  // 직원관리
  {
    // 직원 관리
    path: "/tax-portal/person",
    component: TAXPORTAL_Employee
  },
  // 세무포털관리
  {
    // 홈택스 설정
    path: "/tax-portal/settings/hometax",
    component: TAXPORTAL_SETTINGS_HOMETAX
  },
  {
    // 위택스 설정
    path: "/tax-portal/settings/wetax",
    component: TAXPORTAL_SETTINGS_WETAX
  },
  {
    // 4대보험 설정
    path: "/tax-portal/settings/si4n",
    component: TAXPORTAL_SETTINGS_SI4N
  },

  // 신고관리
  {
    path: "/tax-portal/tax-singo",
    component: TAXPORTAL_TAX_SINGO
  },
  {
    path: "/tax-portal/tax-singo-configuration",
    component: TAXPORTAL_TAX_SINGO_CONFIGURATION
  },

  // 컨설팅
  // {
  //   path: "/tax-portal/tax-consulting/:categoryIdx/board/:boardIdx?",
  //   component: TAXPORTAL_TAX_CONSULTING
  // },
  {
    path: "/tax-portal/tax-consulting/",
    component: TAXPORTAL_TAX_CONSULTING
  },

  {
    path: "/tax-portal/tax-consulting-collaboration",
    component: TAXPORTAL_TAX_CONSULTING_COLLABORATION
  },
  {
    path: "/tax-portal/tax-consulting-setting",
    component: TAXPORTAL_TAX_CONSULTING_SETTING
  },
];

const payPortalRoutes = [
  // PAY_PORTAL
  // 대시보드
  {
    path: "/pay-portal/pay-dashboard",
    component: PAYPORTAL_PayDashboard
  },
];
const routes = [
  // TEST Pages
  {
    path: "/test/mask",
    component: TestMask,
  },
  {
    path: "/test/datepicker",
    component: TestDatePicker,
  },
  {
    path: "/test/buttons",
    component: TestButtons,
  },
  {
    path: "/test/badges",
    component: TestBadges,
  },
  {
    path: "/test/content-layout",
    component: TestContentLayout,
  },
  {
    path: "/test/checkbox-radio",
    component: CheckboxAndRadio,
  },
  {
    path: "/test/redux",
    component: ReduxAndReduxSaga,
  },
  {
    path: "/test/finances-cert",
    component: FinancesCert,
  },

  // 홈
  {
    path: "/dashboard",
    component: Dashboard,
  },
  // 담당자 상담
  {
    path: "/counseling/:counselingType",
    component: Counseling,
  },
  // 할일
  {
    path: "/task",
    component: Task,
  },
  // 커뮤니티
  {
    path: "/community/:communityIdx",
    component: Community,
  },
  {
    path: "/community",
    component: CommunityList,
  },
  {
    path: "/task/issue",
    component: TaskIssue,
  },
  // 출퇴근
  {
    path: "/attendance/history",
    component: AttendanceHistory,
  },
  {
    path: "/attendance/management",
    component: AttendanceManagement,
  },
  {
    path: "/attendance/work-time",
    component: AttendanceWorkTime,
  },
  {
    path: "/attendance/work-department",
    component: AttendanceWorkDepartment,
  },
  {
    path: "/attendance/location",
    component: AttendanceLocation,
  },
  // 근무일정
  {
    path: "/workschedule/management",
    component: WorkScheduleManagement,
  },
  {
    path: "/workschedule/holiday",
    component: WorkScheduleHoliday,
  },
  {
    path: "/workschedule/otherwork",
    component: WorkScheduleOtherWork,
  },
  // 휴가
  {
    path: "/vacation/plan",
    component: VacationPlan,
  },
  // { path: "/vacation/status", component: VacationStatus },
  {
    path: "/vacation/assign-status",
    component: VacationAssignStatus,
  },
  {
    path: "/vacation/standard",
    component: VacationStandard,
  },
  {
    path: "/vacation/other",
    component: VacationOther,
  },
  // 급여
  {
    path: "/salary/self",
    component: SalaryHistorySelf,
  },
  {
    path: "/salary/detail",
    component: SalaryHistory,
  },
  {
    path: "/salary/items",
    component: SalaryItems,
  },
  // 사람
  {
    path: "/person/organization",
    component: PersonOrganization,
  },
  // 전자계약
  {
    path: "/electronic/labor",
    component: ElectronicContract,
  },
  // 자금
  {
    path: "/funds/report",
    component: FundsReport,
  },
  {
    path: "/funds/overview",
    component: FundsOverview,
  },
  {
    path: "/funds/other",
    component: FundsOther,
  },
  {
    path: "/funds/account",
    component: FundsAccount,
  },
  {
    path: "/funds/accout-detail",
    component: FundsAccountDetail,
  },
  {
    path: "/funds/card",
    component: FundsCard,
  },
  {
    path: "/funds/card-detail",
    component: FundsCardDetail,
  },
  {
    path: "/funds/bond-debt",
    component: FundsBondDebt,
  },
  {
    path: "/funds/categories",
    component: Categories,
  },
  // 전자계산서
  {
    path: "/electronic/bill-trade",
    component: ElectronicTradeBill,
  },
  {
    path: "/electronic/bill-tax",
    component: ElectronicTaxBill,
  },
  {
    path: "/electronic/bill-paper-tax",
    component: ElectronicPaperTaxBill,
  },
  {
    path: "/electronic/bill-cash",
    component: ElectronicCashBill,
  },
  {
    path: "/electronic/quotation-order",
    component: QuotationOrder,
  },
  // 경비 청구
  {
    path: "/expenseclaim/list",
    component: ExpenseClaimList,
  },
  // 업로드
  {
    path: "/upload/list",
    component: UploadList,
  },
  // 연말정산
  {
    path: "/year-end/list",
    component: YearEndList,
  },
  // 관리자
  {
    path: "/manager/company-info",
    component: ManagerCompanyInfo,
  },
  {
    path: "/manager/inner-task",
    component: ManagerTask,
  },
  {
    path: "/manager/outer-task",
    component: OutSideTask,
  },
  {
    path: "/manager/financial",
    component: ManagerFinancial,
  },
  {
    path: "/manager/work-place",
    component: ManagerWorkPlace,
  },
  // 품목
  {
    path: "/item/list",
    component: ItemList,
  },
  // 거래처
  {
    path: "/client/list",
    component: ClientList,
  },
  {
    path: "/client/categories",
    component: ClientList,
  },
  // 프로필
  {
    path: "/profile",
    component: Profile,
  },
  // 리다이랙트
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
];

const authRoutes = [
  {
    path: "/logout",
    component: Logout,
  },

  // partners rediract
  {
    path: "/partners",
    component: () => {
      window.location.href = "https://wecake.io/partners?isPrice=true";
      return <></>;
    },
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/forgot-id",
    component: ForgetId,
  },
  {
    path: "/forgot-password",
    component: ForgetPwd,
  },
  {
    path: "/sign-up",
    component: SignUp,
  },
  {
    path: "/sign-up-complete",
    component: SignUpComplete,
  },
  {
    path: "/first-step",
    component: FirstLogin,
  },
  {
    path: "/select-company",
    component: SelectCompany,
  },
  {
    path: "/create-company",
    component: RequestCreateCompany,
  },
  {
    path: "/join-company",
    component: RequestJoinCompany,
  },
  {
    path: "/contract",
    component: ContractWebView,
  },

  {
    path: "/delete-user",
    component: DeleteUser
  }

  // 리다이랙트
];

export {
  adminRoutes,
  taxPortalRoutes,
  payPortalRoutes,
  managerCompanyRoutes,
  routes,
  authRoutes
};
